import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly translate = inject(TranslateService);

  private lastTitleKey = '';

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => {
      if (this.lastTitleKey) {
        this.applyTitle(this.lastTitleKey);
      }
    });
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    this.lastTitleKey = title || '';

    if (title) {
      this.applyTitle(title);
    } else {
      this.titleService.setTitle('ITB Trader Panel');
    }
  }

  private applyTitle(key: string) {
    this.translate.get(key).subscribe((translatedTitle) => {
      this.titleService.setTitle(`ITB | ${translatedTitle}`);
    });
  }
}
